import { PrimaryButton } from "_components/atoms/button";

import useStyles from "./styles";

const component = ( {
	onSubmit = () => { },
	onCancel = () => { },
	hideCancelBtn,
	submitBtnText = "Done",
	cancelBtnText = "Cancel",
	hideSubmitBtn,
	containerClass,
	disabled = false
} ) => {
	const { classes } = useStyles ( undefined, { name: "styles" } );

	return (
		<div className = { `${ containerClass ? containerClass : "" } ${ classes.bottomContainer }` }>

			{
				hideCancelBtn ?
					null : (
						<button
							className = { classes.cancelBtn }
							onClick   = { onCancel }
						>
							{cancelBtnText}
						</button>
					)
			}

			{
				hideSubmitBtn ?
					null : (
						<PrimaryButton
							className = { classes.submitBtn }
							disabled  = { disabled }
							onClick   = { onSubmit }
							title     = { submitBtnText }
						/>
					)
			}
		</div>
	);
};

export default component;
